import Encart from './Encart';
export default Encart;
